/**
 * Container-related type definitions for PackingV2
 * Supports shipment container packing alongside package packing.
 */
var _a;
/** User-facing labels for container scan API `actionType` values */
export var ContainerScanActionLabels = {
    adoptContainer: 'Container adopted onto shipment',
    selectContainer: 'Container selected',
    attachContainer: 'Container attached',
    packIntoContainer: 'Packed into container',
    createAndPackIntoContainer: 'New container created and packed'
};
/** Container status enum values */
export var ContainerStatus = {
    Open: 'ScpOpen',
    Closed: 'ScpClosed'
};
export var ContainerStatusLabels = (_a = {},
    _a[ContainerStatus.Open] = 'Open',
    _a[ContainerStatus.Closed] = 'Closed',
    _a);
